<!-- `maxWidth` muda por passo: na conferência o documento precisa ser LIDO, e 640px espremem o
     PDF a ponto de a pessoa não conseguir conferir o que está confirmando.

     Maximizar (card 3069, reunião de 25/09/2026): mesmo com 920px o termo fica apertado para
     ler. Maximizada, a pré-visualização e a lista de sócios crescem até a altura da tela (ver o
     SCSS). O cabeçalho e o rodapé NÃO são fixos (`fixedHeaderOnMaximize`): o cabeçalho próprio
     tem três linhas e passaria dos 80px que o modo fixo reserva, cobrindo o conteúdo. -->
<app-dialog
  #dialog
  [key]="'term-signatories'"
  [action]="'term-signatories'"
  [headerTheme]="'simple'"
  [maxWidth]="passo === 'conferencia' ? '920px' : '640px'"
  [showMaximizeButton]="true"
  [hideDefaultFooter]="true">
  <!-- Cabeçalho próprio: o `title` simples do app-dialog não comporta sobretítulo e subtítulo,
       e é o subtítulo que diz PARA QUEM o documento vai — a conferência que a pessoa faz antes
       de disparar um convite de assinatura. -->
  <ng-template #title>
    <div class="term-head">
      <span class="term-head__icon" aria-hidden="true">
        <i class="pi pi-pencil"></i>
      </span>
      <div class="term-head__texts">
        <p class="term-head__eyebrow">Assinatura digital · SCR</p>
        <h4 class="term-head__title">{{ titulo }}</h4>
        <p class="term-head__subtitle">
          {{ deal?.corporateName }}
          @if (deal?.cnpj) {
            · CNPJ {{ deal!.cnpj | vaultMaskCnpj }}
          }
        </p>
      </div>
    </div>
  </ng-template>

  <!-- `appAutoFormGroup` obrigatório junto do `[formGroup]`: sem ele o `app-input` cria controle
       próprio, a tela fica preenchida e o formulário nasce vazio e inválido — botão travado, sem
       erro no console. -->
  @if (passo === 'assinantes') {
    <div class="term-modal" [formGroup]="form" appAutoFormGroup>
    <!-- ══════════════════════════ 1. escolha ══════════════════════════ -->
    <div class="term-section__head">
      <h3 class="term-section__title">1. Escolha os signatários</h3>
      <span class="term-section__meta">Quadro societário · Receita Federal</span>
    </div>

    @if (carregandoSugestoes) {
      <p class="term-modal__hint">Consultando o quadro societário...</p>
    } @else if (sugestoes.length) {
      <!-- Teto de altura com rolagem: há CNPJ com muitos sócios (a CSN tem 11), e sem isso a
           lista empurra a seção 2 para fora da tela — que é onde a pessoa precisa chegar. -->
      <div class="partners">
        @for (socio of sugestoes; track socio.name) {
          <div class="partners__row">
            <app-user-avatar [name]="socio.name" size="small" />

            <div class="partners__identity">
              <p class="partners__name">{{ socio.name }}</p>
              @if (socio.qualification) {
                <p class="partners__role">{{ socio.qualification }}</p>
              }
            </div>

            <!-- Escolhido NÃO volta atrás por aqui: quem remove é a lixeira da seção 2. Dois
                 caminhos para desfazer a mesma coisa é como se erra sem perceber. -->
            @if (estaSelecionado(socio.name)) {
              <span class="partners__chosen">
                <i class="pi pi-check" aria-hidden="true"></i>
                Selecionado
              </span>
            } @else if (socio.alreadyAdded) {
              <span class="partners__chosen partners__chosen--muted">Já é signatário</span>
            } @else {
              <button type="button" class="partners__pick" (click)="selecionar(socio)">
                <i class="pi pi-plus" aria-hidden="true"></i>
                Selecionar
              </button>
            }
          </div>
        }
      </div>
    } @else {
      <!-- Vazio é situação NORMAL: CNPJ sem sócios informados, empresa individual, ou consulta
           indisponível. Adicionar fora do quadro é caminho legítimo, não plano B. -->
      <p class="term-modal__hint">
        A Receita não retornou sócios para este CNPJ. Adicione os signatários abaixo.
      </p>
    }

    <!-- ══════════════════════════ 2. e-mails ══════════════════════════ -->
    <div class="term-section__head term-section__head--spaced">
      <h3 class="term-section__title">2. Informe o e-mail de cada signatário</h3>
      <span class="term-section__meta">{{ contagemDeSignatarios }}</span>
    </div>

    <p class="term-notice">
      <i class="pi pi-info-circle" aria-hidden="true"></i>
      <span>
        A Receita Federal não informa e-mails. O convite de assinatura é enviado para o endereço
        preenchido. <strong>Cada signatário precisa de nome e sobrenome</strong> — é exigência do
        provedor de assinatura.
      </span>
    </p>

    <!-- O que o cliente vai precisar fazer para assinar (card 3073). Vem da Parametrização, e
         dizer antes evita o cliente travar num SMS que ninguém avisou que viria. -->
    @if (descricaoDaVerificacao; as descricao) {
      <p class="term-notice">
        <i class="pi pi-shield" aria-hidden="true"></i>
        <span>
          {{ descricao }}
          @if (exigeCelular) {
            <strong>O celular de cada signatário é obrigatório.</strong>
          }
        </span>
      </p>
    }

    @if (!assinantes.length) {
      <p class="term-modal__hint">
        Escolha alguém no quadro acima, ou adicione um signatário fora do quadro.
      </p>
    }

    <div formArrayName="assinantes">
      @for (linha of assinantes.controls; track $index; let i = $index) {
        <div class="signer-card" [formGroupName]="i">
          <div class="signer-card__head">
            @if (linha.get('fromCorporateRegistry')?.value) {
              <p class="signer-card__name">{{ linha.get('name')?.value }}</p>
              @if (linha.get('qualification')?.value) {
                <span class="signer-card__chip">{{ linha.get('qualification')?.value }}</span>
              }
            } @else {
              <span class="signer-card__chip signer-card__chip--outside">Fora do quadro</span>
            }

            <button
              type="button"
              class="signer-card__remove"
              [title]="'Remover este signatário'"
              (click)="removerLinha(i)">
              <i class="pi pi-trash" aria-hidden="true"></i>
            </button>
          </div>

          <!-- Nome só é campo para quem NÃO veio do quadro: editar o nome de um sócio da Receita
               desfaria a única garantia que a lista oferece, a de que a pessoa consta lá. -->
          @if (!linha.get('fromCorporateRegistry')?.value) {
            <label class="signer-card__label" [attr.for]="'nome-' + i">Nome</label>
            <app-input [id]="'nome-' + i" [formGroup]="linha" controlName="name" />

            <!-- A mensagem é escrita aqui, e não pelo `app-input`: o mapeamento genérico do
                 projeto diria só "Campo inválido", que não ensina o que fazer. -->
            @if (linha.get('name')?.hasError('sobrenome') && linha.get('name')?.dirty) {
              <p class="signer-card__erro">Informe nome e sobrenome.</p>
            }
          }

          <!-- O rótulo fica FORA do `app-input`: assim o ícone e o campo ficam lado a lado na
               mesma linha, e o rótulo os encima — que é o desenho.

               Sem asterisco, como no desenho: os dois campos do cartão são obrigatórios, e
               marcar os dois não informa nada. O botão de enviar continua travado sem eles. -->
          <label class="signer-card__label" [attr.for]="'email-' + i">E-mail</label>
          <div class="signer-card__email">
            <i class="pi pi-envelope signer-card__email-icon" aria-hidden="true"></i>
            <app-input [id]="'email-' + i" type="email" [formGroup]="linha" controlName="email" />
          </div>

          <!-- Celular (card 3073): obrigatório quando a assinatura é confirmada por SMS ou
               WhatsApp — sem ele o provedor não tem para onde mandar o código. Opcional por
               e-mail, e aí serve só de contato. -->
          <label class="signer-card__label" [attr.for]="'celular-' + i">
            Celular{{ exigeCelular ? ' (com DDD)' : ' (opcional)' }}
          </label>
          <div class="signer-card__email">
            <i class="pi pi-mobile signer-card__email-icon" aria-hidden="true"></i>
            <app-input
              [id]="'celular-' + i"
              type="tel"
              [placeholder]="'(11) 99999-9999'"
              [formGroup]="linha"
              controlName="phoneNumber" />
          </div>
          @if (linha.get('phoneNumber')?.invalid && linha.get('phoneNumber')?.dirty) {
            <p class="signer-card__erro">
              {{
                linha.get('phoneNumber')?.hasError('required')
                  ? 'Informe o celular: o código de assinatura vai por ' +
                    (verificacao?.auth === 'whatsapp' ? 'WhatsApp.' : 'SMS.')
                  : 'Informe o celular com DDD, ex.: (11) 99999-9999.'
              }}
            </p>
          }
        </div>
      }
    </div>

    <button type="button" class="term-modal__add" (click)="adicionarForaDoQuadro()">
      <i class="pi pi-user-plus" aria-hidden="true"></i>
      Adicionar signatário fora do quadro
    </button>

    <!-- ══════════════════════ 3. quem assina pela Legatus ══════════════════════ -->
    <!-- Só leitura: vem da Parametrização e o parceiro não escolhe a contraparte. Está aqui
         porque a pessoa precisa saber COM QUEM o cliente está assinando antes de disparar. -->
    <div class="term-section__head term-section__head--spaced">
      <h3 class="term-section__title">3. Quem assina pela Legatus</h3>
      <span class="term-section__meta">Parametrização</span>
    </div>

    @if (carregandoLegatus) {
      <p class="term-modal__hint">Carregando...</p>
    } @else if (assinantesDaLegatus.length) {
      <div class="partners">
        @for (l of assinantesDaLegatus; track l.email) {
          <div class="partners__row">
            <app-user-avatar [name]="l.name" [size]="'small'" />
            <div class="partners__identity">
              <p class="partners__name">{{ l.name }}</p>
              <p class="partners__role">{{ l.email }}</p>
            </div>
            <span class="partners__chosen partners__chosen--muted">
              <i class="pi pi-shield" aria-hidden="true"></i>
              Legatus
            </span>
          </div>
        }
      </div>
      <p class="term-modal__hint">
        Entram automaticamente no documento. Para alterar, é na Parametrização do Back Office.
      </p>
    } @else {
      <!-- Lista vazia não é detalhe: sem assinante da Legatus o envio é RECUSADO e o documento
           nunca fecharia. Dizer agora poupa a pessoa de preencher tudo para levar um erro. -->
      <p class="term-danger">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
        <span>
          Nenhum signatário da Legatus está configurado, e sem isso
          <strong>o envio será recusado</strong> — o documento nunca fecharia. Configure em
          Parametrização, no Back Office.
        </span>
      </p>
    }

    <!-- ──────────────── o aviso que mais importa desta modal ──────────────── -->
    @if (termoJaEnviado) {
      <p class="term-danger">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
        <span>
          Acrescentar alguém <strong>cancela o documento atual e envia um novo</strong>. Quem já
          assinou precisará assinar de novo — é assim que o provedor de assinatura funciona.
        </span>
      </p>
    }
    </div>
  } @else {
    <!-- ═══════════════════ passo 2: conferir o documento ═══════════════════ -->
    <div class="term-modal term-modal--preview">
      <p class="term-notice">
        <i class="pi pi-file-pdf" aria-hidden="true"></i>
        <span>
          <strong>Este é o termo que será enviado.</strong> Confira o documento e os signatários
          antes de confirmar — depois do envio, mudar a lista cancela o documento e todos assinam
          de novo.
        </span>
      </p>

      @if (preview) {
        <iframe
          class="term-preview"
          [src]="preview"
          [title]="nomeDoArquivo || 'Documento do termo'"></iframe>
      }
    </div>
  }

  <ng-template #footer>
    <div class="term-foot">
      @if (passo === 'assinantes') {
        <!-- Botão desabilitado sem explicação faz a pessoa procurar o que faltou. Quando o que
             falta é o sobrenome, a nota dá lugar ao motivo. -->
        @if (semSobrenome > 0) {
          <p class="term-foot__note term-foot__note--alerta">
            <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
            <span>
              {{ semSobrenome === 1 ? 'Um signatário está' : semSobrenome + ' signatários estão' }}
              sem sobrenome. O provedor de assinatura exige nome completo.
            </span>
          </p>
        } @else {
          <p class="term-foot__note">
            <i class="pi pi-eye" aria-hidden="true"></i>
            <span>No próximo passo você confere o documento antes de enviar.</span>
          </p>
        }

        <div class="term-foot__actions">
          <app-button
            [label]="'Cancelar'"
            [theme]="'outline-grey'"
            [type]="'button'"
            (sendButtonClick)="fechar()"></app-button>
          <app-button
            [disabled]="!isFormValid()"
            [isLoading]="carregandoPreview"
            [loadingText]="'Montando o documento...'"
            [label]="'Confirmar assinantes'"
            [icon]="'arrow-right'"
            [iconPosition]="'right'"
            [type]="'button'"
            (sendButtonClick)="confirmarAssinantes()"></app-button>
        </div>
      } @else {
        <p class="term-foot__note">
          <i class="pi pi-send" aria-hidden="true"></i>
          <span>
            Ao confirmar, o convite vai por e-mail para
            {{ contagemDeSignatarios }} do cliente e para a Legatus.
          </span>
        </p>

        <div class="term-foot__actions">
          <app-button
            [label]="'Voltar'"
            [theme]="'outline-grey'"
            [icon]="'arrow-left'"
            [disabled]="gravando"
            [type]="'button'"
            (sendButtonClick)="voltarParaAssinantes()"></app-button>
          <app-button
            [isLoading]="gravando"
            [loadingText]="'Enviando...'"
            [label]="rotuloDoBotao"
            [icon]="'send'"
            [iconPosition]="'right'"
            [type]="'button'"
            (sendButtonClick)="submitAction()"></app-button>
        </div>
      }
    </div>
  </ng-template>
</app-dialog>
